import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import CSVTemplate from '../../../components/csvTemplate';
import CustomButton from '../../../components/customButton';

import './styles.scss';
import { generateCsvTemplate, hasData } from './utils';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedProject } from '../../../redux/projects/actions';
import API from '../../../services/api';
import { setAlert } from '../../../redux/dashboard/actions';
import utils from '../../../utils';

const MultipleSitesCreationModal = ({ isOpen, toggle, onCancel }) => {
  const inputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('multiple_sites.csv');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const project = useSelector(getSelectedProject);
  const dispatch = useDispatch();

  // Clear modal information every time it opens
  useEffect(() => {
    if (isOpen) {
      setFile(null);
      setFileName('multiple_sites.csv');
      setError(null);
      setIsLoading(false);
    }
  }, [isOpen]);

  useEffect(() => {
    setError(null);

    if (file) {
      if (file.type === 'text/csv') {
        hasData(file).then(hasContent => {
          setError(null);
          setFileName(file.name);
          if (!hasContent) {
            setError('The CSV file is empty or does not contain data rows.');
          }
        });
      } else {
        setError('File choosen is not a CSV!');
        setFileName(file.name);
      }
    } else {
      setFileName('multiple_sites.csv');
      setError(null);
    }
  }, [file, project?.id]);

  const handleUploadFile = () => {
    if (file) {
      setIsLoading(true);
      API.createUploadUrl(project.id)
        .then(response => {
          API.uploadSiteFile(response.uploadUrl, file)
            .then(() => {
              dispatch(
                setAlert(
                  utils.generateAlert(
                    'File uploaded successfully, you will get notified once processing is complete.',
                    'success'
                  )
                )
              );
            })
            .catch(err => {
              dispatch(setAlert(utils.generateAlert('Error uploading file: ' + err.message, 'error')));
            })
            .finally(() => {
              setIsLoading(false);
              toggle(false);
            });
        })
        .catch(err => {
          dispatch(setAlert(utils.generateAlert('Error creating upload URL: ' + err.message, 'error')));
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const renderInfo = () => {
    if (error || !file) return null;

    return (
      <div className="file-info">
        {'File loaded'}: <b>{fileName}</b>.
      </div>
    );
  };

  return (
    <Modal size="lg" isOpen={isOpen} fade={false} centered id="create-sites-modal">
      <ModalHeader toggle={onCancel ? onCancel : () => toggle(false)}>
        <h2>Create Multiple Sites</h2>
        <div className="modal-subtitle">
          AdMobilize needs each the correct information for each site to multiple creation. Download the CSV model, look
          at the example and complete the real sites information and then upload the completed file. We use comma
          &quot;,&quot; as CSV column separator.
        </div>
      </ModalHeader>
      <ModalBody>
        <CSVTemplate
          fileName={fileName}
          columns={[
            'display_name',
            'type',
            'description',
            'solution',
            'address',
            'latitude',
            'longitude',
            'country_code'
          ]}
        />
        {renderInfo()}
        {error && <div className="error-message">{error}</div>}
        <div className="file-input-container">
          <CustomButton
            title="Download Template"
            classes="btn-secondary"
            icon="download"
            handleClick={() => {
              generateCsvTemplate();
            }}
          />
          <CustomButton
            title="Choose File"
            classes="btn-secondary"
            icon="folder"
            handleClick={() => {
              inputRef.current.click();
            }}
          />
          <input id="input-file-btn" type="file" ref={inputRef} onChange={e => setFile(e.target.files[0])} />
        </div>
      </ModalBody>
      <ModalFooter>
        <CustomButton
          title="Cancel"
          classes="btn-secondary"
          handleClick={() => {
            toggle(false);
          }}
        />
        <CustomButton
          title={'Create Sites'}
          classes="btn-primary"
          disabled={error || !file}
          loading={isLoading}
          handleClick={() => {
            handleUploadFile();
          }}
        />
      </ModalFooter>
    </Modal>
  );
};

export default MultipleSitesCreationModal;
